/**
 * ---------------------
 * Copyright
 * Spinview Global 2018
 * ---------------------
 */

var outdatedBrowserRework = require('outdated-browser-rework');
var fs = require('fs');
var CSS = fs.readFileSync(__dirname + '/style.txt', 'utf8');

var SUPPORTED_BROWSERS = {
	'Chrome': 66,
	'Edge': 40,
	'Safari': 11,
	'Mobile Safari': 11,
	'Firefox': 58,
	'IE': 11,
};

function OutdatedBrowser() {

	this.init = function() {
		var isActive = !!sessionStorage.getItem('active');
		if(!isActive) {
			sessionStorage.setItem('active', true);
			checkBrowser();
		}
	};

	function checkBrowser() {
		var style = document.createElement('style');
		style.type = 'text/css';

		if (style.styleSheet) {
			style.styleSheet.cssText = CSS;
		} else {
			style.appendChild(document.createTextNode(CSS));
		}

		document.getElementsByTagName("head")[0].appendChild(style);

		var div = document.createElement('div');
		div.id = 'outdated';

		document.getElementsByTagName("body")[0].appendChild(div);

		outdatedBrowserRework({
			browserSupport: SUPPORTED_BROWSERS,
			requireChromeOnAndroid: true,
		});
	}
}

module.exports = OutdatedBrowser;
